// PUBLIC
const HOMEPAGE = '/';
const ABOUT = '/hakkimizda';
const NEW_TICKET = '/basvuru-olustur';
const CHECK_TICKET = '/basvuru-sorgula';
const TICKET_SUCCESS = '/basvuru-basarili';
const PUBLIC_TICKET_ITEM = '/basvuru';

// ADMIN
const ADMIN = '/admin';
const ADMIN_TICKET_LIST = '/admin/basvuru-listesi';
const ADMIN_TICKET_ITEM = '/admin/basvuru/';

export {
  HOMEPAGE,
  ABOUT,
  NEW_TICKET,
  CHECK_TICKET,
  TICKET_SUCCESS,
  PUBLIC_TICKET_ITEM,
  ADMIN,
  ADMIN_TICKET_ITEM,
  ADMIN_TICKET_LIST,
};
